import { PlansSection, PropertyDataSection, TableFeatures } from './components';

import './index.css';

interface TabsPropertyDataCommerceProps {
  duplicateId?: number;
  id: number;
}

export const TabsPropertyDataCommerce = ({
  duplicateId,
  id,
}: TabsPropertyDataCommerceProps) => {
  return (
    <div className='mt-1'>
      <PlansSection id={id} duplicateId={duplicateId} />

      <PropertyDataSection id={id} duplicateId={duplicateId} />

      <TableFeatures id={id} duplicateId={duplicateId} />
    </div>
  );
};
